import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PDFService } from "../services/pdf.service";
import { Storage } from "@ionic/storage";
import { ManualPointService } from "../services/manual-point.service";
import { Project } from "../models/project.model";
import { Asset } from "../models/asset.model";
import { File } from "@ionic-native/file";
import { FileOpener } from "@ionic-native/file-opener";
import { Platform, AlertController } from "ionic-angular";
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

@Component({
    selector: 'log-reports-pdf',
    template: `<div id="pdfContent" style="height: 100%"></div>`
})
export class LogReportsPdf {

    @Input() project: Project;
    @Input() asset: Asset;
    @Input() saveOrEmail: string;
    @Output() removePdfComponent = new EventEmitter();
    @Output() showEmailModal = new EventEmitter();

    public pdf: any;
    constructor(
        private pdfService: PDFService,
        private storage: Storage,
        private manualPointService: ManualPointService,
        private file: File,
        private fileOpener: FileOpener,
        private platform: Platform,
        private alertCtrl: AlertController
    ) { }

    ngOnInit() {
        this.pdf = this.pdfService.get();
        this.iniatePDFOperation(this.saveOrEmail);
        //this.constructPdfHTML(this.saveOrEmail);
    }

    constructPdfHTML(type) {
        this.toDataURL('assets/imgs/r-header-new.png', (base64) => {

            let data = `<div style="padding: 16px; height: 100%">`;
            data = data + `<div><img src="assets/imgs/r-header-new.png" style="width: 100%" />`;
            data = data + `<h5 style="position: absolute; top: 36px; color: white; right: 48px; font-size: 8px">PLANNED SERVICE</h5>
                           <h5 style="position: absolute; top: 45px; color: white; right: 48px; font-size: 6px; font-weight: bold">Log Report</h5>
                           <h5 style="position: absolute; top: 56px; left: 70px; font-size: 8px; font-weight: bold; color: rgb(9,86,159);">Log Report</h5>
                           </div>`;
            data = data + `
                <table style="width: 100%; border-collapse: separate; border-spacing: 0px 6px !important; font-size: 10px !important;">
                    <tr>
                        <td style="width: 25% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: center !important; 
                                   text-transform: uppercase !important;
                                   background: rgb(9,86,159); 
                                   color: white;">Site Location</td>
                        <td style="width: 75% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: left !important; 
                                   padding-left: 16px !important;
                                   text-transform: uppercase !important;
                                   border-top: 2px solid rgb(9,86,159);
                                   border-bottom: 2px solid rgb(9,86,159);
                                   border-right: 10px solid rgb(9,86,159);">RAYONIER INC - JESUP MILL</td>
                    </tr>
                    <tr>
                        <td style="width: 25% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: center !important; 
                                   text-transform: uppercase !important;
                                   background: rgb(9,86,159); 
                                   color: white;">Equipment</td>
                        <td style="width: 75% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: left !important; 
                                   padding-left: 16px !important;
                                   text-transform: uppercase !important;
                                   border-top: 2px solid rgb(9,86,159);
                                   border-bottom: 2px solid rgb(9,86,159);
                                   border-right: 10px solid rgb(9,86,159);">YT Annex 34126</td>
                    </tr>
                    <tr>
                        <td style="width: 25% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: center !important; 
                                   text-transform: uppercase !important;
                                   background: rgb(9,86,159); 
                                   color: white;">Date</td>
                        <td style="width: 75% !important; 
                                   padding-top: 5px; 
                                   padding-bottom: 5px; 
                                   text-align: left !important; 
                                   padding-left: 16px !important;
                                   text-transform: uppercase !important;
                                   border-top: 2px solid rgb(9,86,159);
                                   border-bottom: 2px solid rgb(9,86,159);
                                   border-right: 10px solid rgb(9,86,159);">25-08-2016 15:45:45</td>
                    </tr>
                </table>`
            let rows = "";

            for (var i = 0; i < 10; i++) {
                if (i == 0) {
                    rows += `<tr>
                                <td rowspan="10" style="border: 1px solid black; text-align: center !important; font-weight: bolder; width: 10%">
                                    <label style="font-size: 8px; display: inline-block !important; transform: rotate(-90deg) !important;">Compressor</label>
                                </td>
                                <td style="font-size: 8px; border-top: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-bottom: 5px; width: 65%">COND-SMALL-TEMP DIFF</td>
                                <td style="font-size: 8px; border-top: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-bottom: 5px; width: 25%">8.5degF</td>
                            </tr>`
                }
                else {
                    rows += `<tr>
                                <td style="font-size: 8px; border-top: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-bottom: 5px">COND-SMALL-TEMP DIFF</td>
                                <td style="font-size: 8px; border-top: 1px solid black; border-right: 1px solid black; padding-top: 5px; padding-bottom: 5px">8.5degF</td>
                            </tr>`
                }
            }
            data = data + `<table style="border-collapse: collapse; width: 100%; margin-top: 16px;">${rows}</table>`;
            data = data + `<footer style="color: #bcbcbc; position: absolute; bottom: 0px; left: 32px; text-align: left">
                                <p style="margin-bottom: 0px; font-size: 5px">Johnson Controls, Inc.</p>
                                <p style="margin-bottom: 0px; font-size: 5px; margin-top: 0px;">Confidential</p>
                                <p style="margin-bottom: 0px; font-size: 5px; margin-top: 0px;">Do Not Copy (physically, electronically, or in any other media) without the express written permission of Johnson Controls, Inc</p>
                           </footer>`
            data = data + `</div>`
            //this.iniatePDFOperation(type, data);
        })
    }

    iniatePDFOperation(type) {
       
            if (type == "email") {
               
                this.showEmailModal.emit(false);
            }
            else {
                
                this.removePdfComponent.emit(false);
            }
           
        // let pdf = new jsPDF('12', 'px', 'a4');
        // document.getElementById("pdfContent").innerHTML = data;
        // this.createHtmlImage(pdf, 'pdfContent', 15, 0, true, () => {
        //     if (type == "email") {
        //         let base64 = pdf.output('datauristring');
        //         base64 = base64.replace("data:application/pdf;base64,","");
        //         this.showEmailModal.emit(base64);
        //     }
        //     else {
        //         pdf.save('report.pdf');
        //         this.removePdfComponent.emit(true);
        //     }
        //     document.getElementById("pdfContent").innerHTML = "";
        // });
        // let options = {
        //     data: data,
        //     documentSize: 'A4',
        //     type: "base64",
        //     landscape: 'portrait'
        // }
        // let self = this;
        // this.pdf.htmlToPDF(options, (output) => {
        //     if (type == "email") {
        //         this.showEmailModal.emit(output);
        //     }
        //     else {
        //         let blob = this.b64toBlob(output, 'application/pdf', 512);
        //         let fileName = `LogReports-${Date.now()}.pdf`;
        //         let filePath = this.file.externalApplicationStorageDirectory;
        //         if(this.platform.is("ios")) {
        //             filePath = this.file.dataDirectory;
        //         }
        //         this.file.writeFile(filePath, fileName, blob, { replace : true })
        //             .then(success => {
        //                 self.fileOpener.open(filePath + fileName, "application/pdf" )
        //                     .then(response => {
        //                         self.removePdfComponent.emit(true);
        //                     })
        //                     .catch(err => {
        //                         self.removePdfComponent.emit(true);
        //                     })
        //                 self.removePdfComponent.emit(true);
        //             })
        //             .catch(error => {
        //                 console.log(JSON.stringify(error));
        //                 self.removePdfComponent.emit(true);
        //             })
        //     }
        // }, (error) => {
        //     console.log("Inside error");
        // })
    }

    createHtmlImage(pdf, elementId, x, y, isLastPage, callback) {
        html2canvas(document.getElementById(elementId), {
            useCORS: true,
            height: 800
        }).then((canvas) => {
            var img = canvas.toDataURL("image/png");
            pdf.addImage(img, 'PNG', x, y);
            pdf.setFontSize(8);
            callback();
        });
    }

    toDataURL(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

}


// WEBPACK FOOTER //
// ./src/templates/log-reports-pdf.component.ts